/*
 * @Author: 麦勇潮
 * @Date: 2019-06-13 18:08:24
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2020-10-21 11:14:30
 * 个人中心，账号路由
 */
import FN from '../common/fn'
export default [{
  path: '/v1/personal',
  name: 'Personal',
  component: resolve => require(['@/pages/Personal'], resolve),
  meta: {
    title: '个人中心',
    keepAlive: false,
    isLoding: true
    // keepAlive: true
  }
},
{
  path: '/v1/changepassword',
  name: 'ChangePassword',
  component: resolve => require(['@/pages/personal/changePassword'], resolve),
  meta: {
    title: '修改密码'
  }
},
{
  path: '/v1/bindphone',
  name: 'BindPhone',
  component: resolve => require(['@/pages/personal/bindPhone'], resolve),
  meta: {
    title: '绑定手机'
  }
},
{
  path: '/v1/bindemail',
  name: 'BindEmail',
  component: resolve => require(['@/pages/personal/bindEmail'], resolve),
  meta: {
    title: '绑定邮箱'
  }
},
{
  path: '/v1/name',
  name: 'Name',
  component: resolve => require(['@/pages/personal/name'], resolve),
  meta: {
    title: '实名认证'
  }
},
{
  path: '/v1/remindernotices',
  name: 'Remindernotices',
  component: resolve => require(['@/pages/personal/reminderNotices'], resolve),
  meta: {
    title: '消息提醒'
  }
},
{
  path: '/v1/notice',
  name: 'notice',
  component: resolve => require(['@/pages/personal/notice'], resolve),
  meta: {
    title: '公告'
  }
},
{
  path: '/v1/device',
  name: 'device',
  component: resolve => require(['@/pages/personal/device'], resolve),
  meta: {
    title: '设备管理'
  }
},
{
  path: '/v1/cplinfo',
  name: 'cplinfo',
  component: resolve => require(['@/pages/personal/cplInfo'], resolve),
  meta: {
    title: '完善信息'
  }
},
{
  path: '/v1/pay',
  name: 'pay',
  component: resolve => require(['@/pages/pay/pay'], resolve),
  meta: {
    title: '支付信息'
  }
},
{
  path: '/v1/alipay404',
  name: 'alipay404',
  component: resolve => require(['@/pages/404/alipay'], resolve),
  meta: {
    title: '支付提示'
  }
},
{
  path: '/v1/hongbao',
  name: 'hongbao',
  component: resolve => require(['@/pages/hongbao'], resolve),
  meta: {
    title: '红包中心',
    keepAlive: false
  }
},
{
  path: '/v1/new_hongbao',
  name: 'new_hongbao',
  component: resolve => require(['@/pages/new_hongbao'], resolve),
  meta: {
    title: '红包中心',
    keepAlive: false
  }
},
{
  path: '/v1/qqqun',
  name: 'qqqun',
  component: resolve => require(['@/pages/personal/qqqun'], resolve),
  meta: {
    title: '官方Q群'
  }
}
]



// WEBPACK FOOTER //
// ./src/router/personalRouterV1.js